import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { type FieldErrors, type TopicsState, type RelevantTopicAnchorRow, type GeneralTopicItem } from "./useTaskCreation";
import { CostEstimate } from "./CostEstimate";
import { AnchorTableRow } from "./AnchorTableRow";

export function RelevantTopicTable(props: {
  rows: RelevantTopicAnchorRow[];
  topics: GeneralTopicItem[];
  topicsState: TopicsState;
  groupErrors: FieldErrors;
  disabled: boolean;
  onResetToTextarea: () => void;
  onRetryTopics: () => void;
  onSetAnchorRow: (
    anchorIndex: number,
    field: keyof RelevantTopicAnchorRow,
    value: string | number,
  ) => void;
}) {
  const { rows, topics } = props;
  const estimate = CostEstimate.relevantTopicGroupEstimate(rows);

  return (
        <>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="subtitle2">Анкоры ({rows.length})</Typography>
            <Button
              size="small"
              variant="text"
              onClick={props.onResetToTextarea}
            >
              ← Вернуться к textarea
            </Button>
          </Box>
          {props.groupErrors.anchors && (
            <Alert severity="error" sx={{ mb: 1 }}>{props.groupErrors.anchors}</Alert>
          )}
          {props.topicsState.kind === "error" && (
            <Alert
              severity="error"
              sx={{ mb: 1 }}
              action={
                <Button color="inherit" size="small" onClick={props.onRetryTopics}>
                  Повторить
                </Button>
              }
            >
              {props.topicsState.message}
            </Alert>
          )}
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Анкор</TableCell>
                <TableCell width={100}>Количество</TableCell>
                <TableCell width={130}>Уникальность, %</TableCell>
                <TableCell>Тема</TableCell>
                <TableCell width={130} align="right">Уникальных статей</TableCell>
                <TableCell width={110} align="right">Стоимость</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <AnchorTableRow
                  key={index}
                  row={row}
                  index={index}
                  topics={topics}
                  uniqueArticles={estimate.perAnchor[index].uniqueArticles}
                  cost={estimate.perAnchor[index].cost}
                  disabled={props.disabled}
                  onSetRow={props.onSetAnchorRow}
                />
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell colSpan={4}>
                  <Typography variant="subtitle2">Всего</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="subtitle2">{estimate.totalUniqueArticles}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="subtitle2">{CostEstimate.formatCost(estimate.totalCost)}</Typography>
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </>
  );
}
